<script>
/**
 * Component: Packages: Chappell
 *
 * @author RO
 * 
 * Description
 * This component was created for the needs of the portal Chappell.
 * Component is used to choose the payment type before choosing the packets.
 */
export default {
  props: ["current", "chappell"],

  data: function() {
    return {};
  },

  computed: {
    value: {
      get() {
        return this.$store.getters.getSectionSettings("packages", "chappell")
          .current;
      },
      set(value) {
        const settings = this.$store.getters.getSectionSettings(
          "packages",
          "chappell"
        );
        if (settings) {
          settings.current = value;

          this.$store.commit("updateSectionSettings", {
            section: "packages",
            values: {
              chappell: settings
            }
          });
        }
      }
    }
  }
};
</script>

<template>
  <div class="signup-packages-chappell">
    <div class="signup-packages-chappell__title">
      <p>Please select your Payment Type:</p>
    </div>
    <div class="signup-packages-chappell__select">
      <select name="test" id="test" v-model.lazy="value">
        <option
          v-for="chappell_pt in chappell"
          v-bind:key="chappell_pt.id"
          :value="chappell_pt.id"
        >{{chappell_pt.title}}<span v-if="chappell_pt.description">:</span> {{chappell_pt.description}}</option>
      </select>
    </div>
  </div>
</template>

